function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils/twMerge";
import { Link as LinkComponent } from "../Link";
export function LinkButton(props) {
    var tmp = props.as, As = tmp === void 0 ? "a" : tmp, _variant = props.variant, variant = _variant === void 0 ? "default" : _variant, _theme = props.theme, theme = _theme === void 0 ? "default" : _theme, subtle = props.subtle, icon = props.icon, className = props.className, children = props.children, rest = _objectWithoutProperties(props, [
        "as",
        "variant",
        "theme",
        "subtle",
        "icon",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(As, _extends({
        className: className
    }, rest), /*#__PURE__*/ React.createElement(LinkComponent, {
        as: "span",
        variant: variant,
        className: twMerge(cx("group grid grid-cols-1 items-center gap-5 transition-all", !!icon && "grid-cols-[minmax(0,1fr)_auto]", theme === "default" && "text-brand-primary-base hover:text-brand-primary-light", theme === "secondary" && "text-brand-secondary-base hover:text-brand-secondary-light", theme === "primary-light" && "text-brand-primary-light", theme === "default" && variant !== "big" && "text-brand-primary-base border-b border-transparent py-2 hover:border-fg-default hover:text-brand-primary-base"))
    }, /*#__PURE__*/ React.createElement("span", {
        className: "grid grid-cols-1 items-center isolate"
    }, variant === "big" && /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: twMerge("col-start-1 row-start-1 rounded-full bg-fg-inverted w-[4rem] h-[4rem] scale-100 transition-all group-hover:scale-125", subtle && "opacity-20")
    }), /*#__PURE__*/ React.createElement("span", {
        className: cx("col-start-1 row-start-1 z-10 transition-all", variant === "big" && "pl-7")
    }, children)), !!icon && /*#__PURE__*/ React.createElement("span", {
        className: cx("text-fg-default flex flex-col [&>svg]:h-[1em] [&>svg]:w-auto", variant === "big" && "transition-all group-hover:translate-x-5", variant === "big" && theme === "default" && "group-hover:text-brand-primary-light", variant === "big" && theme === "secondary" && "group-hover:text-brand-secondary-light")
    }, icon)));
}

//# sourceMappingURL=LinkButton.js.map